var map = {
	"./icon_action.svg": 1239,
	"./icon_card.svg": 4155,
	"./icon_cardinput.svg": 4949,
	"./icon_email.svg": 3999,
	"./icon_email_selected.svg": 1349,
	"./icon_jpki.svg": 2947,
	"./icon_mynumber.svg": 8560,
	"./icon_openid.svg": 482,
	"./icon_pittari.svg": 7278,
	"./icon_qrcode.svg": 9391,
	"./icon_qrcode_selected.svg": 3797,
	"./icon_serial.svg": 2201,
	"./icon_signing.svg": 7402,
	"./icon_sp_messages.svg": 2123,
	"./icon_vc.svg": 2864,
	"./icon_vc_issuer.svg": 1450,
	"./icon_verification.svg": 5392,
	"./icon_vp.svg": 4291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2683;